import { createSelector } from 'reselect';
import config from './../../config';

export const checkPlanPermission = (billingPermissions, permission) =>
  billingPermissions && billingPermissions[permission];

export const getMenuItems = (profile, paths, billingPermissions, checkPermission) => {
  let tabs = {};
  tabs[paths.profileCharts] = {
    name: 'Projects',
    icon: 'bar-chart'
  };

  if (config.billing.enabled && checkPermission('team_management', profile)) {
    tabs[paths.profileSubscription] = {
      name: 'Subscription',
      icon: 'cloud'
    };
  }
  if (checkPermission('view_users', profile))
    tabs[paths.profileTeamMembers] = {
      name: 'Members',
      icon: 'users'
    };
  if (checkPermission('admin', profile))
    tabs[paths.profileTeamGroups] = {
      name: 'Access groups',
      icon: 'lock'
    };

  if (checkPermission('theme_management', profile))
    tabs[paths.profileTeamThemes] = {
      name: 'Themes',
      icon: 'paint-brush'
    };
  if (checkPermission('customise_editor', profile))
    tabs[paths.profileCustomiseEditor] = {
      name: 'Customize editor',
      icon: 'edit'
    };

  if (!config.billing.enabled || checkPermission('api_key_management', profile))
    tabs[paths.profileApi] = {
      name: 'API',
      icon: 'code'
    };

  tabs[paths.profileWebhooks] = {
    name: 'Webhooks',
    icon: 'reply'
  };
  tabs[paths.profileSettings] = {
    name: 'Settings',
    icon: 'cog'
  };
  tabs['documentation'] = {
    name: 'Documentation',
    icon: 'question',
    link: 'https://help.everviz.com/'
  };
  return tabs;
};
